<template>
  <div class="row q-pa-md items-center">
    <div style="display: inline-block" class="text-h6">
      <q-btn @click="$emit('close')" flat>
        <q-icon name="mdi-arrow-left"> </q-icon>
      </q-btn>
      Results {{ raceIndex + 1 }} / {{ round.races.length }}
    </div>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="$store.dispatch('settings/toggleVirtualScrolling')"
      dense
      v-if="$q.screen.gt.xs"
    >
      <q-icon size="xs" name="mdi-printer"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="startScanner"
      dense
    >
      <q-icon size="xs" name="mdi-nfc-variant"></q-icon>
    </q-btn>
    <q-btn
      class="q-ml-md q-px-xs"
      color="secondaryButton"
      text-color="accent"
      no-caps
      unelevated
      @click="finishEvent"
      dense
    >
      Finish Event
    </q-btn>
    <q-space />
    <!-- <q-input
      style="max-width: 70%"
      filled
      v-model="rfid"
      debounce="200"
      label="Scan RFID"
      clearable
      dense
    >
      <template #prepend>
        <q-icon name="mdi-magnify"> </q-icon>
      </template>
    </q-input> -->
    <!-- <q-btn icon="mdi-close" flat @click="$emit('close')"> </q-btn> -->
    <div
      class="col-12 mt-0 pt-0"
      :style="
        `${
          !disableVirtualScrolling
            ? 'height: calc(100vh - 280px) !important'
            : ''
        }`
      "
    >
      <div
        v-if="disableVirtualScrolling"
        style="width: 100%;
    height: 100%; z-index: 9999999; opacity: 0; background-color: black; position: absolute;"
      ></div>
      <datatable
        :filter="search"
        :flat="true"
        :data="participants"
        :columns="columns"
        :row-key="
          participants && participants[0]['associationsMembers_id']
            ? 'associationsMembers_id'
            : 'id'
        "
        @rowDoubleClick="handleDoubleClick"
        :hidePagination="true"
      >
        <template slot="body-cell-placing" slot-scope="data">
          <q-td :props="data.props">
            <q-checkbox
              style="display: inline-block"
              v-model="data.props.row.finished"
              :true-value="1"
              :false-value="0"
              @input="
                updateValue(
                  data.props.row.id,
                  data.props.row.finished,
                  data.props.row,
                  data.props.row.associationsMembers_id
                )
              "
            ></q-checkbox>
            <q-select
              v-if="
                event &&
                  (event.teamsRaceEvent != 1 ||
                    (round.generatedFromNextProgression == 1 &&
                      round.isPlacingsRound))
              "
              v-model="data.props.row.placing"
              :options="placingOptions"
              map-options
              option-label="label"
              option-value="value"
              :emit-value="true"
              dense
              style="display: inline-block; width: 80px"
              @input="
                updatePlacing(
                  data.props.row.id,
                  data.props.row.placing,
                  data.props.row,
                  data.props.row.master_time,
                  true
                )
              "
            ></q-select>

            <q-select
              v-else
              v-model="data.props.row.memberPlacing"
              :options="placingOptions"
              map-options
              option-label="label"
              option-value="value"
              :emit-value="true"
              dense
              style="display: inline-block; width: 80px"
              @input="
                updatePlacing(
                  data.props.row.id,
                  data.props.row.memberPlacing,
                  data.props.row,
                  data.props.row.master_time,
                  true,
                  data.props.row.associationsMembers_id
                )
              "
            ></q-select>

            <br />

            <q-btn
              dense
              class="full-width q-mt-sm"
              :label="
                `${
                  data.props.row.dqCode_id ? data.props.row.dqNumber : 'Select'
                }`
              "
              :color="data.props.row.dqCode_id ? 'primary' : 'negative'"
              v-if="['DQ', 'DNS', 'DNF'].includes(data.props.row.placing)"
              no-caps
            >
              <q-menu>
                <div
                  class="row q-pa-md full-width"
                  style="min-width: 500px; max-width: 500px"
                >
                  <div class="column full-width">
                    <div class="text-h6 q-mb-md">
                      {{ data.props.row.placing }} Code
                      <assignDQCodes
                        class="q-ml-sm"
                        style="display: inline-block; width: calc(100% - 120px)"
                        :id="data.props.row.dqCode_id"
                        :currentDQ="data.props.row.placing"
                        :discipline_id="event.discipline_id"
                        @changed="
                          val => {
                            data.props.row.dqCode_id = val;
                            updateDQCode(
                              data.props.row.id,
                              data.props.row.dqCode_id,
                              data.props.row.master_time,
                              data.props.row
                            );
                          }
                        "
                      />
                    </div>
                  </div>
                  <div v-if="data.props.row.dqCode_id" class="col-12">
                    <div class="text-h6 q-mb-md">
                      Code: {{ data.props.row.dqNumber }}
                    </div>
                    <p>
                      {{
                        dqCodes.find(dq => dq.id == data.props.row.dqCode_id)
                          .description
                      }}
                    </p>
                  </div>
                </div>
              </q-menu>
            </q-btn>

            <!-- <q-select
              v-if="['DQ', 'DNS', 'DNF', 'DNR'].includes(data.props.row.placing)"
              v-model="data.props.row.placing"
              :options="placingOptions"
              map-options
              option-label="label"
              option-value="value"
              :emit-value="true"
              dense
              style="display: inline-block; width: calc(100% - 120px)"
              @input="updatePlacing(data.props.row.id, data.props.row.placing)"
            >
            </q-select> -->
          </q-td>
        </template>
        <template slot="body-cell-master_time" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            <q-input
              dense
              v-model="data.props.row.master_time"
              label="Qual Time"
              mask="##:##.##"
              reverse-fill-mask
              placeholder="mm:ss:hs"
              input-class="text-right"
              @blur="
                updatePlacing(
                  data.props.row.id,
                  data.props.row.placing,
                  data.props.row,
                  data.props.row.master_time
                )
              "
            >
            </q-input>
          </q-td>
        </template>
        <template slot="body-cell-capUrl" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            <q-img
              v-if="data.props.row.capUrl"
              :src="data.props.row.capUrl"
              style="width: 40px"
              contain
            >
            </q-img>
            <q-img
              v-else
              src="https://nzsls.s3.ap-southeast-2.amazonaws.com/associationAssets/Composite+Teams+Cap.png"
              style="width: 40px"
              contain
            >
            </q-img>
          </q-td>
        </template>
        <template slot="body-cell-firstName" slot-scope="data">
          <q-td
            v-if="!data.props.row.team_name"
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            style="
              min-width: 150px;
              max-width: 150px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
               line-height: 14px
            "
            :props="data.props"
          >
            {{ data.props.row.firstName }} {{ data.props.row.lastName }}
            <q-icon
              v-if="data.props.row.rfid"
              color="blue-grey"
              size="xs"
              name="mdi-tag-text"
            >
              <q-tooltip>RFID - {{ data.props.row.rfid }}</q-tooltip>
            </q-icon>
            <br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
          <q-td
            v-else-if="
              event.teamsRaceEvent != 1 ||
                (round.generatedFromNextProgression == 1 &&
                  round.isPlacingsRound)
            "
            style="
              min-width: 150px;
              max-width: 150px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
               line-height: 14px
            "
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
          >
            <b>{{ data.props.row.team_name }}</b> <br />
            <span
              style="font-size: 10px"
              v-for="(member, index) in data.props.row.members"
              :key="`member_${index}`"
            >
              {{ member.firstName }} {{ member.lastName }}
              {{ index < data.props.row.members.length - 1 ? ", " : "" }}
            </span>
            <br />
            <span style="font-size: 10px; font-weight: bold;">
              {{
                data.props.row.association_abbr
                  ? data.props.row.association_abbr
                  : "Composite"
              }}
            </span>
          </q-td>
          <q-td
            v-else
            style="
              min-width: 150px;
              max-width: 150px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            "
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
          >
            <b>{{ data.props.row.firstName }} {{ data.props.row.lastName }}</b>
            <br />
            <span style="font-size: 10px">
              {{ data.props.row.team_name }}
            </span>
          </q-td>
        </template>
        <template slot="body-cell-eventPoints" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            {{ data.props.row.eventPoints }}
          </q-td>
        </template>
        <template slot="body-cell-eventPlacing" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            {{
              data.props.row.eventPlacing
                ? ordinal_suffix_of(data.props.row.eventPlacing)
                : ""
            }}
          </q-td>
        </template>
        <template slot="body-cell-event_name" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            {{ data.props.row.event_name }}
          </q-td>
        </template>
        <template slot="body-cell-points" slot-scope="data">
          <q-td
            :class="{
              resultsPlacingRowAlert:
                data.props.row.placing == 'DQ' ||
                data.props.row.placing == 'DNF' ||
                data.props.row.placing == 'DNR' ||
                data.props.row.placing == 'DNS'
            }"
            :props="data.props"
          >
            <q-input
              v-if="data.props.row.placing"
              dense
              type="number"
              v-model="data.props.row.points"
              @blur="updatePoints(data.props.row)"
            >
            </q-input>
          </q-td>
        </template>
      </datatable>
    </div>
    <div class="col-12 q-mt-sm" style="margin-top: 9px; z-index: 2">
      <div class="row items-center">
        <q-btn no-caps color="blue-grey" @click="$emit('close')">Close</q-btn>
        <q-btn
          no-caps
          color="blue-grey"
          @click="resetLocalChanges"
          class="q-ml-sm"
          >Reset Local Changes</q-btn
        >
        <!-- <q-btn color="blue-grey" @click="reset()" class="q-ml-md">Reset</q-btn> -->
        <div class="col"></div>
        <q-btn
          no-caps
          color="primary"
          :loading="publishLoading"
          @click="publish()"
          class="float-right"
          >Publish</q-btn
        >
      </div>
    </div>
    <q-dialog v-model="teamDetailsModel">
      <teamDetailsCard :team="currentTeamDetails" />
    </q-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import datatable from "@/components/datatable/datatable.vue";
import assignDQCodes from "@/components/dqCodes/assignDQCodes.vue";

export default {
  components: { datatable, assignDQCodes },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      event: "events/current",
      competition: "competitions/current",
      siteCFG: "settings/siteCFG",
      dqCodes: "dqCodes/list",
      disableVirtualScrolling: "settings/disableVirtualScrolling",
      cachedData: "localCached/events"
    }),
    columns: function() {
      let pointsType =
        this.round.progress_to == 5 ||
        this.round.round_name == "Final" ||
        this.round.round_name == "Final 1"
          ? "Fnl Pts"
          : "Points";

      return [
        {
          name: "placing",
          label: "Placing",
          align: "left",
          field: "placing",
          classes: row => {
            return row.placing == "DQ" ||
              row.placing == "DNF" ||
              row.placing == "DNS" ||
              row.placing == "DNR"
              ? "resultsPlacingRowAlert"
              : "";
          },
          sort: (aa, bb, a, b) => {
            if (a.placing && a.placing.includes("D")) return 1;
            if (b.placing && b.placing.includes("D")) return -1;

            if (a.placing && !b.placing) return -1;
            if (b.placing && !a.placing) return 1;

            if (Number(a.placing) > Number(b.placing)) return 1;
            if (Number(a.placing) < Number(b.placing)) return -1;

            if (a.finished && !b.finished) return -1;
            if (b.finished && !a.finished) return 1;
            return 0;
          },
          style:
            "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;",
          sortable: true
        },
        {
          name: "associationsMembers_id",
          label: "associationsMembers_id",
          align: "left",
          field: "associationsMembers_id",
          classes: row => {
            return row.placing == "DQ" ||
              row.placing == "DNF" ||
              row.placing == "DNS" ||
              row.placing == "DNR"
              ? "resultsPlacingRowAlert"
              : "";
          },
          hide: true,
          style:
            "min-width: 130px;max-width: 130px;width: 130px;white-space: nowrap;overflow: hidden;",
          sortable: true
        },
        {
          name: "placing_teamsRace",
          label: "Placing",
          align: "left",
          field: "placing",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            this.event.teamsRaceEvent != 1 ||
            (this.round.generatedFromNextProgression == 1 &&
              this.round.isPlacingsRound),
          classes: row => {
            return row.placing == "DQ" ||
              row.placing == "DNF" ||
              row.placing == "DNS" ||
              row.placing == "DNR"
              ? "resultsPlacingRowAlert"
              : "";
          },
          format: (val, row) =>
            row.placing ? `${row.placing}/${row.overall_placing}` : ``,
          sortable: true
        },
        {
          name: "master_time",
          label: "Master Time",
          align: "left",
          field: "master_time",
          style:
            "min-width: 80px;max-width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.competition ||
            this.competition.competition_type != "POOL" ||
            (this.event.teamsRaceEvent == 1 && !this.round.isPlacingsRound),
          sortable: true
        },
        {
          name: "lane_no",
          label: "Ln.",
          align: "left",
          field: "lane_no",
          format: val => val,
          style:
            "min-width: 50px;max-width: 50px;width: 50px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          classes: row => {
            return row.placing == "DQ" ||
              row.placing == "DNF" ||
              row.placing == "DNS" ||
              row.placing == "DNR"
              ? "resultsPlacingRowAlert"
              : "";
          },
          sortable: true
        },
        {
          name: "capUrl",
          label: "Club",
          align: "left",
          field: "capUrl",
          style:
            "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "firstName",
          label: "Name",
          align: "left",
          field: "firstName",
          style:
            "min-width: 100px;max-width: 100px;width: 100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

          sortable: true
        },
        {
          name: "points",
          label: pointsType,
          align: "left",
          field: "points",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true
        },
        {
          name: "eventPlacing",
          label: "Event Placing",
          align: "left",
          field: "eventPlacing",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents ||
            this.event.combinedEvents.length < 1 ||
            this.round.races[this.raceIndex].ce_overallFinal ||
            this.round.races[this.raceIndex].ce_eventFinal,
          sortable: true
        },
        {
          name: "eventPoints",
          label: "Event Points",
          align: "left",
          field: "eventPoints",
          style:
            "min-width: 60px;max-width: 60px;width: 60px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents ||
            this.event.combinedEvents.length < 1 ||
            this.round.races[this.raceIndex].ce_overallFinal ||
            this.round.races[this.raceIndex].ce_eventFinal,
          sortable: true
        },
        {
          name: "event_name",
          label: "Event",
          align: "left",
          field: "event_name",
          style:
            "min-width: 250px;max-width: 250px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          hide:
            !this.event.combinedEvents || this.event.combinedEvents.length < 1,
          sortable: true
        }
      ];
    }
  },
  props: {
    round: {
      default: null
    },
    raceIndex: {
      default: 0
    }
  },
  data: () => ({
    rfid: "",

    participants: [],
    participantsFinished: [],

    // Grid

    placingOptions: [],
    publishLoading: false,

    teamDetailsModel: false,
    currentTeamDetails: {},

    search: "",

    fromCache: false
  }),
  watch: {
    round: function() {
      this.init();
    },
    participants: {
      deep: true,
      handler() {
        console.log("testing");
        this.$store.dispatch("localCached/setEventsLocal", this.participants);
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleDoubleClick() {},
    resetLocalChanges() {
      this.$store.dispatch("localCached/clearParticipants", this.participants);
      this.init();
    },
    init() {
      if (
        this.cachedData[this.round.races[this.raceIndex].id] &&
        !this.checkForOverrideChanges()
      ) {
        this.participants = this.cachedData[
          this.round.races[this.raceIndex].id
        ].participants;

        this.participantsFinished = this.participants
          .filter(p => p.placing)
          .map(p => p.id);

        if (this.placingOptions.length == 0) {
          this.participants.forEach((element, index) => {
            this.placingOptions.push({
              label: this.ordinal_suffix_of(index + 1),
              value: `${index + 1}`
            });
          });
          this.placingOptions.push({
            label: "DQ",
            value: "DQ"
          });
          this.placingOptions.push({
            label: "DNF",
            value: "DNF"
          });
          this.placingOptions.push({
            label: "DNS",
            value: "DNS"
          });

          this.placingOptions.push({
            label: "DNR",
            value: "DNR"
          });
        }
      } else {
        if (
          this.event.teamsRaceEvent != 1 ||
          (this.round.generatedFromNextProgression == 1 &&
            this.round.isPlacingsRound)
        ) {
          this.participants = this.round.races[this.raceIndex].lanes.filter(
            l => l.checked_in == 1
          );
        } else {
          this.participants = this.surfTeamsRaceParticipants();
        }

        this.participantsFinished = this.participants
          .filter(p => p.placing)
          .map(p => p.id);

        if (this.placingOptions.length == 0) {
          this.participants.forEach((element, index) => {
            this.placingOptions.push({
              label: this.ordinal_suffix_of(index + 1),
              value: `${index + 1}`
            });
          });
          this.placingOptions.push({
            label: "DQ",
            value: "DQ"
          });
          this.placingOptions.push({
            label: "DNF",
            value: "DNF"
          });
          this.placingOptions.push({
            label: "DNS",
            value: "DNS"
          });

          this.placingOptions.push({
            label: "DNR",
            value: "DNR"
          });
        }
        if (
          this.participants &&
          this.participants[0] &&
          this.participants[0].placing &&
          !this.participants[0].finished
        ) {
          this.calculatePlacings();
        }
      }
    },
    checkForOverrideChanges() {
      let participantTest = [];
      if (
        this.event.teamsRaceEvent != 1 ||
        (this.round.generatedFromNextProgression == 1 &&
          this.round.isPlacingsRound)
      ) {
        participantTest = this.round.races[this.raceIndex].lanes.filter(
          l => l.checked_in == 1
        );
      } else {
        participantTest = this.surfTeamsRaceParticipants();
      }

      if (
        !this.cachedData[this.round.races[this.raceIndex].id] ||
        participantTest.length !=
          this.cachedData[this.round.races[this.raceIndex].id].participants
            .length
      ) {
        return true;
      }

      return false;
    },
    surfTeamsRaceParticipants() {
      let participants = [];
      this.round.races[this.raceIndex].lanes.forEach(team => {
        if (team.checked_in == 1) {
          const tmPlacings = team.teamMembersPlacings
            ? JSON.parse(team.teamMembersPlacings)
            : {};
          team.members.forEach(member => {
            if (!member.playerLabel.includes("Reserve")) {
              let p = JSON.parse(JSON.stringify(team));
              p.firstName = member.firstName;
              p.lastName = member.lastName;
              p.associationsMembers_id = member.associationsMembers_id;
              p.playerLabel = member.playerLabel;
              p.memberPlacing = tmPlacings[member.associationsMembers_id]
                ? `${tmPlacings[member.associationsMembers_id]}`
                : null;
              p.finished = tmPlacings[member.associationsMembers_id] ? 1 : 0;
              participants.push(p);
            }
          });
          participants.sort((a, b) => {
            if (Number(a.lane_no) > Number(b.lane_no)) return 1;
            if (Number(a.lane_no) < Number(b.lane_no)) return -1;
            if (a.playerLabel < b.playerLabel) return -1;
            if (a.playerLabel > b.playerLabel) return 1;
            return 0;
          });
        }
      });
      return participants;
    },
    ordinal_suffix_of(i) {
      var j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + "st";
      }
      if (j == 2 && k != 12) {
        return i + "nd";
      }
      if (j == 3 && k != 13) {
        return i + "rd";
      }
      return i + "th";
    },
    addMember() {},
    calculatePlacings() {
      let tempParticipants = JSON.parse(JSON.stringify(this.participants));
      tempParticipants.forEach(participant => {
        if (participant.master_time) {
          let newTime = "00:00.00".split("");
          let oldMasterTime = participant["master_time"].split("");
          let currentPosition = 7;
          for (let i = oldMasterTime.length - 1; i >= 0; i--) {
            newTime[currentPosition] = oldMasterTime[i];
            currentPosition -= 1;
          }
          participant["master_time"] = newTime.join("");
        }
      });

      tempParticipants.sort((a, b) => {
        if (a.master_time || b.master_time) {
          if (a.placing && a.placing.includes("D")) return 1;
          if (b.placing && b.placing.includes("D")) return -1;
          if (!a.master_time) return 1;
          if (!b.master_time) return -1;

          let t1 = Number(
            a.master_time.replaceAll(":", "").replaceAll(".", "")
          );
          let t2 = Number(
            b.master_time.replaceAll(":", "").replaceAll(".", "")
          );
          if (isNaN(t1)) return 1;
          if (isNaN(t2)) return -1;
          if (t1 < t2) return -1;
          if (t1 > t2) return 1;
        }

        if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
          if (a.memberPlacing && a.memberPlacing.includes("D")) return 1;
          if (b.memberPlacing && b.memberPlacing.includes("D")) return -1;

          if (a.memberPlacing && !b.memberPlacing) return -1;
          if (b.memberPlacing && !a.memberPlacing) return 1;

          if (Number(a.memberPlacing) > Number(b.memberPlacing)) return 1;
          if (Number(a.memberPlacing) < Number(b.memberPlacing)) return -1;
        } else {
          if (a.placing && a.placing.includes("D")) return 1;
          if (b.placing && b.placing.includes("D")) return -1;

          if (a.placing && !b.placing) return -1;
          if (b.placing && !a.placing) return 1;

          if (Number(a.placing) > Number(b.placing))
            return this.event.reversePlacings ? -1 : 1;
          if (Number(a.placing) < Number(b.placing))
            return this.event.reversePlacings ? 1 : -1;
        }

        if (a.finished && !b.finished) return -1;
        if (b.finished && !a.finished) return 1;

        return 0;
      });

      let currentEventPlacings = {};

      let teamsRaceEvent = {};

      let participantsPlacedCount = 0;
      let eventParticipantsPlacedCounts = {};

      if (this.event.reversePlacings) {
        // Getting participants Placed count
        tempParticipants.forEach((participant, index) => {
          // Combined Events Support
          if (!eventParticipantsPlacedCounts[participant.events_id]) {
            eventParticipantsPlacedCounts[participant.events_id] = 0;
          }

          if (participant.placing && !participant.placing.includes("D")) {
            participantsPlacedCount += 1;

            // Combined Events Support
            eventParticipantsPlacedCounts[participant.events_id] += 1;
          }

          // Including current placed member
          if (
            (participant.finished || participant.master_time) &&
            !participant.placing
          ) {
            participantsPlacedCount += 1;
            // Combined Events Support
            eventParticipantsPlacedCounts[participant.events_id] += 1;
          }
        });
      }

      tempParticipants.forEach((participant, index) => {
        if (
          participant.master_time ||
          participant.finished ||
          participant.placing
        ) {
          if (
            (participant.master_time &&
              (!participant.placing || !participant.placing.includes("D"))) ||
            (!participant.placing && !participant.memberPlacing)
          ) {
            // Overall Placing
            if (
              index > 0 &&
              participant.master_time &&
              tempParticipants[index - 1].master_time == participant.master_time
            ) {
              participant.placing = tempParticipants[index - 1].placing;
            } else {
              if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
                participant.memberPlacing = `${
                  this.event.reversePlacings
                    ? tempParticipants.length - index
                    : index + 1
                }`;
              } else {
                participant.placing = `${
                  this.event.reversePlacings
                    ? participantsPlacedCount - index
                    : index + 1
                }`;
              }
            }
          } else {
            // Reverse Placings altering previous participants
            if (
              this.event.reversePlacings &&
              participant.placing &&
              !participant.placing.includes("D") &&
              !participant.manuallySet
            ) {
              if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
                participant.memberPlacing = `${participantsPlacedCount -
                  index}`;
              } else {
                participant.placing = `${participantsPlacedCount - index}`;
              }
            }
          }

          // Teams Race Event
          if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
            if (typeof teamsRaceEvent[participant.lane_no] == "undefined") {
              teamsRaceEvent[participant.lane_no] = 0;
            }

            if (
              !participant.memberPlacing.includes("D") &&
              !`${teamsRaceEvent[participant.lane_no]}`.includes("D")
            ) {
              teamsRaceEvent[participant.lane_no] += parseInt(
                participant.memberPlacing
              );
            } else if (participant.memberPlacing.includes("D")) {
              teamsRaceEvent[participant.lane_no] = participant.memberPlacing;
            }
          }

          // Event Placing

          if (!participant.placing || !participant.placing.includes("D")) {
            if (
              typeof currentEventPlacings[participant.events_id] == "undefined"
            ) {
              // console.log(currentEventPlacings);
              currentEventPlacings[participant.events_id] = [];
              // console.log(currentEventPlacings);
            }

            if (
              currentEventPlacings[participant.events_id].length > 0 &&
              currentEventPlacings[participant.events_id][
                currentEventPlacings[participant.events_id].length - 1
              ].master_time == participant.master_time &&
              participant.master_time
            ) {
              // If master time is the same, set placing to save as previous
              participant.eventPlacing =
                currentEventPlacings[participant.events_id][
                  currentEventPlacings[participant.events_id].length - 1
                ].eventPlacing;
              currentEventPlacings[participant.events_id].push(participant);
            } else {
              // Reverse Placings
              if (this.event.reversePlacings) {
                participant.eventPlacing =
                  participant.manuallySet &&
                  Object.keys(eventParticipantsPlacedCounts).length == 1
                    ? participant.placing // If not combined event and placing was manually set, leave the event placing the same as the actual placing
                    : eventParticipantsPlacedCounts[participant.events_id] -
                      currentEventPlacings[participant.events_id].length;
              } else {
                // Normal Placings
                participant.eventPlacing =
                  currentEventPlacings[participant.events_id].length + 1;
              }
              // Setting new Placing number

              currentEventPlacings[participant.events_id].push(participant);
            }
          } else {
            participant.eventPlacing = null;
          }

          participant.finished = 1;
        }

        if (!participant.pointsManuallySet) {
          if (
            participant.placing &&
            !participant.placing.includes("D") &&
            this.round.pointsTable &&
            this.round.pointsTable[participant.placing - 1]
          ) {
            participant.points = this.round.pointsTable[
              participant.placing - 1
            ].value;
          } else {
            participant.points = 0;
          }
        }

        if (
          participant.eventPlacing &&
          this.round.pointsTable &&
          this.round.pointsTable[participant.eventPlacing - 1]
        ) {
          participant.eventPoints = this.round.pointsTable[
            participant.eventPlacing - 1
          ].value;
        } else {
          participant.eventPoints = 0;
        }
      });

      if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
        for (const [key, value] of Object.entries(teamsRaceEvent)) {
          let totalMembers = tempParticipants.filter(p => p.lane_no == key);

          let membersFinished = tempParticipants.filter(
            p => p.memberPlacing && p.lane_no == key
          );
          if (totalMembers.length == membersFinished.length) {
            totalMembers.forEach(p => {
              p.overall_placing = value;
            });
          } else {
            totalMembers.forEach(p => {
              p.overall_placing = null;
            });
          }
        }

        tempParticipants.sort((a, b) => {
          if (a.overall_placing && `${a.overall_placing}`.includes("D"))
            return 1;
          if (b.overall_placing && `${b.overall_placing}`.includes("D"))
            return -1;

          if (a.overall_placing && !b.overall_placing) return -1;
          if (b.overall_placing && !a.overall_placing) return 1;

          if (Number(a.overall_placing) > Number(b.overall_placing)) return 1;
          if (Number(a.overall_placing) < Number(b.overall_placing)) return -1;

          return 0;
        });

        let currentPlacing = 0;
        let completedLanes = [];
        tempParticipants.forEach(participant => {
          // console.log(participant.overall_placing);
          if (!completedLanes.includes(participant.lane_no)) {
            completedLanes.push(participant.lane_no);
            currentPlacing += 1;
          }
          if (participant.overall_placing) {
            participant.placing = `${
              `${participant.overall_placing}`.includes("D")
                ? participant.overall_placing
                : currentPlacing
            }`;

            participant.eventPlacing = `${
              `${participant.overall_placing}`.includes("D")
                ? null
                : currentPlacing
            }`;
          } else {
            participant.placing = null;
          }

          if (!participant.pointsManuallySet) {
            if (
              participant.placing &&
              !participant.placing.includes("D") &&
              this.round.pointsTable &&
              this.round.pointsTable[participant.placing - 1]
            ) {
              participant.points = this.round.pointsTable[
                participant.placing - 1
              ].value;
            } else {
              participant.points = 0;
            }
          }
        });
      }

      tempParticipants.sort((a, b) => {
        if (Number(a.lane_no) > Number(b.lane_no)) return 1;
        if (Number(a.lane_no) < Number(b.lane_no)) return -1;
        if (a.playerLabel < b.playerLabel) return -1;
        if (a.playerLabel > b.playerLabel) return 1;
        return 0;
      });

      this.participants = tempParticipants;
    },
    updateValue(id, value, row, associationsMembers_id = false) {
      if (row.finished == 0) {
        row.placing = null;
        row.master_time = null;
        if (this.event.teamsRaceEvent && !this.round.isPlacingsRound) {
          row.memberPlacing = null;
        }
      }
      this.calculatePlacings();
    },
    updatePlacing(
      id,
      value,
      row,
      master_time = null,
      manuallySet = false,
      associationsMembers_id = false
    ) {
      if (master_time || row.finished || value) {
        row.finished = 1;
        row.manuallySet = manuallySet;
        this.calculatePlacings();
      }
    },
    updateDQCode(id, val, master_time, row) {
      let dq = this.dqCodes.find(e => e.id == val);
      row.dqNumber = dq ? dq.number : null;
      this.calculatePlacings();
    },
    updatePoints(row) {
      row.pointsManuallySet = true;
      this.calculatePlacings();
    },
    publish() {
      this.publishLoading = true;

      this.$store
        .dispatch("events/publishResults", {
          id: this.round.races[this.raceIndex].id,
          participants: this.participants,
          teamsRaceEvent:
            this.event.teamsRaceEvent && !this.round.isPlacingsRound,
          generateCombinedFinals:
            this.event.combinedEvents &&
            this.event.combinedEvents.length > 0 &&
            !this.round.races[this.raceIndex].ce_overallFinal &&
            !this.round.races[this.raceIndex].ce_eventFinal &&
            !this.round.races[this.raceIndex].ce_events_id &&
            (this.round.round_name == "Final 1" ||
              this.round.round_name == "Final") &&
            this.round.races.length == 1
        })
        .then(result => {
          this.publishLoading = true;
          if (result.Result == "Success") {
            this.round.races[this.raceIndex].resultsPublished = 1;
            this.$store.dispatch(
              "eventProgress/loadCurrentRound",
              this.round.id
            );
            this.$store.dispatch(
              "competitions/updateOmega",
              this.$route.params.competitions_id
            );

            this.$store.dispatch(
              "eventProgress/loadRounds",
              this.round.events_id
            );
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$emit("close");
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    reset() {
      this.$store
        .dispatch("events/publishResults", {
          id: this.round.races[this.raceIndex].id
        })
        .then(result => {
          this.publishLoading = true;
          if (result.Result == "Success") {
            this.round.races[this.raceIndex].resultsPublished = 1;
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message
            });
            this.$emit("close");
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later"
            });
          }
        });
    },
    finishEvent() {
      this.participants.forEach(p => {
        if (
          (this.event && this.event.teamsRaceEvent != 1) ||
          (this.round.generatedFromNextProgression == 1 &&
            this.round.isPlacingsRound)
        ) {
          if (!p.placing) {
            p.placing = "DNR";
            p.finished = 1;
            console.log(p);
          }
        } else {
          if (!p.memberPlacing) {
            p.memberPlacing = "DNR";
            p.finished = 1;
          }
        }
      });

      this.calculatePlacings();
    },

    // Start Scanner
    async handleNFCScan(message, serialNumber, extraData) {
      // ADD NFC to Member
      try {
        // Find Member Via NFC
        let NFCFound = false;

        // Team
        if (this.participants[0].team_name) {
          this.participants.forEach(team => {
            team.members.forEach(member => {
              member.NFCTags.forEach(tag => {
                if (tag.serialNumber == serialNumber) {
                  team.finished = 1;
                  this.updateValue(
                    team.id,
                    1,
                    team,
                    team.associationsMembers_id
                  );
                  NFCFound = true;
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "Member Scanned Successfully"
                  });
                }
              });
            });
          });
        } else {
          // Individual
          this.participants.forEach(member => {
            member.NFCTags.forEach(tag => {
              if (tag.serialNumber == serialNumber) {
                member.finished = 1;
                this.updateValue(
                  member.id,
                  1,
                  member,
                  member.associationsMembers_id
                );
                NFCFound = true;
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Member Scanned Successfully"
                });
              }
            });
          });
        }

        if (!NFCFound) {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Member Not Found"
          });
        }
      } catch (error) {
        console.log(error);
        this.$q.notify({
          position: "top-right",
          type: "negative",
          message: "There was an error, Please try again later"
        });
      }
    },
    startScanner() {
      this.$store.dispatch("NFC/startScanner", {
        $this: this,
        handleNFCScan: this.handleNFCScan
      });
    }
  }
};
</script>

<style lang="scss">
.resultsPlacingRowAlert {
  background: rgba(255, 145, 145, 0.534) !important;
}
</style>
